/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Company } from 'types/entities/Company'

interface MergeCompaniesSearchTagsListProps {
    tags: { term: string; results: Company[] }[]
    onRemoveTag: (term: string) => void
}

const MergeCompaniesSearchTagsList = (
    props: MergeCompaniesSearchTagsListProps
) => {
    if (!props.tags.length) {
        return null
    }

    return (
        <div className="MergeCompaniesSearchTagsList flex flex-wrap gap-2 px-1">
            {props.tags.map((tag, index) => {
                const colorConfigs = [
                    'bg-gradient-to-r from-emerald-500/10 to-emerald-600/10 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800/50',
                    'bg-gradient-to-r from-amber-500/10 to-amber-600/10 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800/50',
                    'bg-gradient-to-r from-orange-500/10 to-orange-600/10 text-orange-700 dark:text-orange-400 border-orange-200 dark:border-orange-800/50',
                    'bg-gradient-to-r from-red-500/10 to-red-600/10 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800/50',
                    'bg-gradient-to-r from-blue-500/10 to-blue-600/10 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-800/50',
                ]
                const colorClass = colorConfigs[index % colorConfigs.length]

                return (
                    <div
                        key={tag.term}
                        className={clsx(
                            'flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold animate-in zoom-in-95 duration-200 shadow-sm',
                            colorClass
                        )}
                    >
                        <span>
                            {tag.term} ({tag.results.length})
                        </span>
                        <button
                            onClick={() => props.onRemoveTag(tag.term)}
                            className="p-0.5 hover:bg-black/5 dark:hover:bg-white/5 rounded-md transition-colors opacity-60 hover:opacity-100"
                        >
                            <XMarkIcon className="w-3.5 h-3.5" />
                        </button>
                    </div>
                )
            })}
        </div>
    )
}

export default MergeCompaniesSearchTagsList
